import { createFileRoute } from "@tanstack/react-router";
import { seoFor } from "@/lib/i18n/keywordPools";
import Privacy from "@/pages/Privacy";
import { MainLayout } from "@/components/layout/MainLayout";

export const Route = createFileRoute("/privacy")({
  head: () => ({
    meta: [
      { title: "Privacy Policy | Statlign" },
      { name: "keywords", content: seoFor({ topics: ["privacy"] }).meta },
      { name: "description", content: "How Statlign collects, uses, and protects your data — accounts, credits, cookies, analytics, advertising, third-party processors, retention, transfers, and your privacy rights." },
      { property: "og:title", content: "Privacy Policy | Statlign" },
      { property: "og:type", content: "website" },
      { property: "og:description", content: "How Statlign collects, uses, and protects your data — accounts, credits, cookies, analytics, advertising, third-party processors, retention, transfers, and your privacy rights." },
      { name: "twitter:title", content: "Privacy Policy | Statlign" },
      { name: "twitter:description", content: "How Statlign collects, uses, and protects your data — accounts, credits, cookies, analytics, advertising, third-party processors, retention, transfers, and your privacy rights." },
    ],
  }),
  component: () => (
    <MainLayout>
      <Privacy />
    </MainLayout>
  ),
});
